<template>
    <div class="openAmount">
        {{ openAmount }}
    </div>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import ClubTransactionInvoice from '../../../js/dto/ClubTransactionInvoice.js';

export default {
    components: {},
    props: {
        value: {
            required: true,
            validator(value) {
                return value instanceof ClubInvoice || value instanceof ClubTransactionInvoice;
            },
        },
    },
    computed: {
        openAmount() {
            if (this.value.status.status === ClubInvoice.STATUS_UNEQUAL
                || this.value.dunningAmount !== null
                || (this.value.chargeback !== null && this.value.chargeback.amount !== null)) {
                let invoiceAmount;
                if (this.value instanceof ClubInvoice && this.value.reverseInvoice !== undefined) {
                    invoiceAmount = 0;
                } else {
                    invoiceAmount = this.value.gross.data.numerator / this.value.gross.data.denominator;
                }
                let sumPayments = 0.0;
                this.value.payments.forEach((payment) => {
                    sumPayments += payment.money.numerator / payment.money.denominator;
                });
                const difference = (Math.round((invoiceAmount - sumPayments) * 100) / 100 || 0).toFixed(2).replace('.', ',');
                return `(offener Betrag: ${difference} ${this.value.currency})`;
            }
            return '';
        },
    },
};
</script>

<style>
.openAmount {
    margin-top: 10px;
}
</style>
